import { ProductCommodityGroupAPI } from '../../api/Catalog';

export const PIZZA_COMMODITY_GROUP = ProductCommodityGroupAPI.OWN_KITCHEN;
